(function () {
  'use strict';

  function parseJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try { return JSON.parse(node.textContent); } catch (error) { return fallback; }
  }

  function money(amount) {
    var value = Number(amount || 0);
    var whole = value % 100 === 0;
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(value / 100);
  }

  function init(root) {
    var scope = root || document;
    var pdp = scope.querySelector('[data-sp-pdp]');
    if (!pdp || pdp.dataset.spInit === '1') return;
    pdp.dataset.spInit = '1';

    var variants = parseJson(pdp, '[data-sp-variants]', []);
    var optionNames = parseJson(pdp, '[data-sp-option-names]', []);
    var genericInputs = Array.prototype.slice.call(pdp.querySelectorAll('[data-sp-option]'));
    var legacyInputs = Array.prototype.slice.call(pdp.querySelectorAll('.sp-size__input:not([data-sp-option])'));
    var sizeInputs = genericInputs.filter(function (input) {
      return String(input.dataset.optionName || '').toLowerCase() === 'size';
    });
    if (!sizeInputs.length) sizeInputs = legacyInputs;

    var colourInputs = genericInputs.filter(function (input) {
      var name = String(input.dataset.optionName || '').toLowerCase();
      return name === 'color' || name === 'colour';
    });
    var variantInput = pdp.querySelector('[data-sp-variant]');
    var atbLabel = pdp.querySelector('[data-sp-atb-label]');
    var atbButton = pdp.querySelector('.sp-pdp__atb');
    var priceEl = pdp.querySelector('[data-sp-price], .sp-pdp__price');
    var stickyPrice = document.querySelector('[data-sp-sticky-price]');
    var accel = pdp.querySelector('[data-sp-accel]');
    var sizeField = pdp.querySelector('[data-sp-size-field]') || (sizeInputs[0] && sizeInputs[0].closest('.sp-pdp__field'));
    var baseLabel = (atbButton && atbButton.dataset.baseLabel) || 'Add to Bag';
    var bar = document.querySelector('[data-sp-stickybar]');
    var barBtn = bar && bar.querySelector('.sp-stickybar__btn');
    var selectedSizeExplicitly = false;
    var anyAvailable = variants.length
      ? variants.some(function (variant) { return variant.available !== false; })
      : sizeInputs.some(function (input) { return !input.disabled; });

    function setPurchaseState(variant) {
      var complete = selectedSizeExplicitly && Boolean(variant);
      var available = complete && variant.available !== false;
      if (variantInput) {
        if (complete) {
          variantInput.value = String(variant.id);
          variantInput.setAttribute('value', String(variant.id));
        } else {
          variantInput.value = '';
          variantInput.removeAttribute('value');
        }
        variantInput.disabled = !complete;
      }
      if (atbButton) atbButton.disabled = !available;
      if (accel) {
        accel.classList.toggle('is-enabled', available);
        accel.setAttribute('aria-hidden', String(!available));
      }
      var label = !anyAvailable ? 'Sold out' : (!complete ? 'Select a size' : (available ? baseLabel : 'Sold out'));
      if (atbLabel) atbLabel.textContent = label;
      if (barBtn) barBtn.textContent = label;
      if (complete && variant && variant.price != null) {
        var renderedPrice = money(variant.price);
        if (priceEl) priceEl.textContent = renderedPrice;
        if (stickyPrice) stickyPrice.textContent = renderedPrice;
      }
    }

    function selectedValues() {
      var values = {};
      genericInputs.forEach(function (input) {
        if (input.checked) values[input.dataset.optionName] = input.value;
      });
      return values;
    }

    function resolveVariant() {
      if (!variants.length) {
        var checkedLegacy = legacyInputs.filter(function (input) { return input.checked; })[0];
        if (!checkedLegacy) return null;
        return { id: checkedLegacy.value, available: !checkedLegacy.disabled, price: null };
      }
      var values = selectedValues();
      return variants.filter(function (variant) {
        return optionNames.every(function (name, index) {
          return values[name] && variant.options[index] === values[name];
        });
      })[0] || null;
    }

    function selectedColour() {
      var c = colourInputs.filter(function (input) { return input.checked; })[0];
      return c ? c.value : null;
    }

    function updateUrl(variant, mode) {
      var url = new URL(window.location.href);
      if (variant && selectedSizeExplicitly) url.searchParams.set('variant', variant.id);
      else url.searchParams.delete('variant');
      var state = { spVariant: variant && selectedSizeExplicitly ? String(variant.id) : null, spColour: selectedColour() };
      var prev = window.history.state || {};
      // Only add a history entry when something the visitor can see changed.
      if (mode === 'pushState' && prev.spVariant === state.spVariant && prev.spColour === state.spColour && url.toString() === window.location.href) mode = 'replaceState';
      window.history[mode || 'replaceState'](state, '', url.toString());
    }

    function updateAvailability() {
      if (!variants.length) return;
      var values = selectedValues();
      sizeInputs.forEach(function (input) {
        var possible = variants.some(function (variant) {
          if (variant.available === false) return false;
          return optionNames.every(function (name, index) {
            if (String(name).toLowerCase() === 'size') return variant.options[index] === input.value;
            return !values[name] || variant.options[index] === values[name];
          });
        });
        input.disabled = !possible;
      });
    }

    function updateGallery() {
      if (!colourInputs.length) return;
      var selected = colourInputs.filter(function (input) { return input.checked; })[0];
      if (!selected) return;
      var colours = colourInputs.map(function (input) { return input.value.toLowerCase(); });
      var active = selected.value.toLowerCase();
      var figures = Array.prototype.slice.call(pdp.querySelectorAll('[data-sp-media]'));
      figures.forEach(function (figure) {
        var taggedColour = figure.dataset.colour;
        if (taggedColour === undefined) {
          var image = figure.querySelector('img');
          var alt = String((image && image.alt) || '').toLowerCase();
          taggedColour = colours.filter(function (colour) { return alt.indexOf(colour) !== -1; })[0];
        }
        figure.hidden = Boolean(taggedColour && taggedColour !== active);
      });
      var lead = figures.filter(function (figure) { return !figure.hidden; })[0];
      figures.forEach(function (figure) { figure.classList.toggle('is-lead', figure === lead); });
      var total = pdp.querySelector('[data-sl-total]');
      if (total) total.textContent = String(figures.filter(function (figure) { return !figure.hidden; }).length);
      var track = pdp.querySelector('.sl-pdp__track');
      if (track) track.scrollLeft = 0;
      var label = pdp.querySelector('[data-sp-colour-label]');
      if (label) label.textContent = selected.value;
    }

    function applySelection(mode) {
      updateAvailability();
      updateGallery();
      var variant = resolveVariant();
      setPurchaseState(variant);
      updateUrl(variant, mode);
    }

    function primeFormVariant() {
      var variant = resolveVariant();
      if (!variantInput || !selectedSizeExplicitly || !variant) return;
      variantInput.disabled = false;
      variantInput.value = String(variant.id);
      variantInput.setAttribute('value', String(variant.id));
    }

    function restoreFromUrl() {
      var id = new URL(window.location.href).searchParams.get('variant');
      if (!id) {
        var st = window.history.state;
        if (st && st.spColour) {
          colourInputs.forEach(function (input) { input.checked = input.value === st.spColour; });
        }
        sizeInputs.forEach(function (input) { input.checked = false; });
        selectedSizeExplicitly = false;
        applySelection('replaceState');
        return;
      }
      if (variants.length) {
        var variant = variants.filter(function (item) { return String(item.id) === String(id); })[0];
        if (!variant) return;
        optionNames.forEach(function (name, index) {
          genericInputs.filter(function (input) {
            return input.dataset.optionName === name && input.value === variant.options[index];
          }).forEach(function (input) { input.checked = true; });
        });
        selectedSizeExplicitly = true;
      } else {
        legacyInputs.forEach(function (input) { input.checked = String(input.value) === String(id); });
        selectedSizeExplicitly = legacyInputs.some(function (input) { return input.checked; });
      }
      updateAvailability();
      updateGallery();
      setPurchaseState(resolveVariant());
    }

    genericInputs.concat(legacyInputs).forEach(function (input) {
      input.addEventListener('change', function () {
        var name = String(input.dataset.optionName || 'size').toLowerCase();
        if (name === 'size') selectedSizeExplicitly = true;
        applySelection('pushState');
      });
    });

    window.addEventListener('popstate', restoreFromUrl);
    restoreFromUrl();

    var productForm = variantInput && variantInput.closest('form');
    if (productForm) productForm.addEventListener('submit', primeFormVariant, true);
    if (atbButton) atbButton.addEventListener('click', primeFormVariant, true);
    if (accel) accel.addEventListener('click', primeFormVariant, true);

    if (barBtn && atbButton) {
      barBtn.addEventListener('click', function () {
        if (!selectedSizeExplicitly) {
          if (sizeField) {
            sizeField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var firstAvailable = sizeInputs.filter(function (input) { return !input.disabled; })[0];
            if (firstAvailable) firstAvailable.focus({ preventScroll: true });
          }
          return;
        }
        if (!atbButton.disabled) atbButton.click();
      });
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-in', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }, { rootMargin: '0px' });
        observer.observe(atbButton);
      }
    }

    var track = pdp.querySelector('.sl-pdp__track');
    var count = pdp.querySelector('[data-sl-count]');
    if (track && count) {
      track.addEventListener('scroll', function () {
        var visible = Array.prototype.slice.call(track.querySelectorAll('[data-sp-media]:not([hidden])'));
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        count.textContent = String(Math.min(index + 1, visible.length));
      }, { passive: true });
    }

    var guideBtn = pdp.querySelector('[data-sp-sizeguide]');
    var guide = pdp.querySelector('#sp-sizeguide');
    if (guideBtn && guide) {
      guideBtn.addEventListener('click', function () {
        var open = guide.hidden;
        guide.hidden = !open;
        guideBtn.setAttribute('aria-expanded', String(open));
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
